<template>
  <div class="w-full flex flex-col 3sm:mt-0 xs:mt-20 px-6">
    <div
      class="monster-type-wrapper relative overflow-hidden w-227 h-12 float-left"
    >
      <span
        class="monster-type absolute inset-0 m-auto w-full text-very-light-gray xs:text-2 uppercase text-center z-10 flex items-center justify-center"
        >MONSTERS</span
      >
      <div class="absolute w-162 h-12 inset-0 m-auto bg-vivid-pink"></div>
    </div>
    <div class="slider-cont w-full">
      <div class="monster-carousel slider-wrapper relative">
        <VueSlickCarousel
          ref="monsterSlider"
          v-bind="settings"
          @beforeChange="beforeChangeCarousel"
        >
          <div
            class="monster-slide"
            v-for="(monsterSlide, index) in monsterData"
            :key="index"
          >
            <div
              class="monster-name font-rakkas 3sm:text-8.4xl sm:text-5 xs:text-30 text-white"
              v-html="monsterSlide.name"
            ></div>

            <div class="3sm:w-full xs:w-7/12 3sm:-mt-162 2sm:mt-20 sm:mt-32">
              <img
                class="w-full"
                :src="`${imgPath}/Section06/${monsterSlide.monsterImg}`"
              />
            </div>
            <div class="flex flex-col 3sm:-mt-162 xs:mt-14">
              <p
                v-html="monsterSlide.desc"
                class="mt-8 font-mulish-regular text-very-light-gray 3sm:text-1.8 xs:text-1.2 3sm:tracking-wider xs:tracking-normal 3sm:leading-2.2 xs:leading-1.6"
              ></p>
            </div>
          </div>
          <template #customPaging="page">
            <div
              class="dots-wrapper relative custom-dot sm:w-66 sm:h-66 xs:w-16 xs:h-16 box-content"
            >
              <div
                class="slick-dots-active sm:w-66 sm:h-66 xs:w-16 xs:h-16 rounded-full absolute inset-center z-10"
              ></div>
              <img
                class="absolute sm:w-66 sm:h-66 xs:w-16 xs:h-16 inset-center"
                :src="`${imgPath}/Section06/${monsterPaging[page]}`"
              />
            </div>
          </template>
        </VueSlickCarousel>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel';
export default {
  components: { VueSlickCarousel },
  data: function() {
    return {
      activePage: 0,
      settings: {
        dots: true,
        arrows: false,
        autoplay: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    };
  },
  methods: {
    beforeChangeCarousel: function(oldIndex, newIndex) {
      this.activePage = newIndex;
    },
    goToSlide: function(index) {
      this.$refs.monsterSlider.goTo(index);
    },
  },
  computed: {
    ...mapState({
      monsterData: state => state.MonsterSection.monsterData,
      monsterPaging: state => state.MonsterSection.monsterPaging,
      imgPath: state => state.AppConfig.imgPath,
    }),
  },
};
</script>

<style lang="postcss" scoped>
.monster-type-wrapper:before {
  content: '';
  position: absolute;
  top: -15px;
  left: 0px;
  border-top: 30px solid transparent;
  border-right: 30px solid #fc1aa7;
  border-bottom: 40px solid transparent;
  height: 66%;
  width: 0;
}
.monster-type-wrapper:after {
  content: '';
  position: absolute;
  top: -15px;
  right: 0px;
  border-top: 30px solid transparent;
  border-left: 30px solid #fc1aa7;
  border-bottom: 40px solid transparent;
  height: 66%;
  width: 0;
}
.monster-carousel >>> .slick-dots {
  @apply 3sm:w-full sm:w-232 xs:w-152 3sm:max-w-75 3sm:h-auto sm:h-464 xs:h-188 flex 3sm:flex-row xs:flex-col 3sm:justify-between xs:justify-center 3sm:left-0 xs:left-auto xs:right-0 md:-bottom-36 3sm:-bottom-32 xs:bottom-auto 3sm:top-auto 2sm:top-24 sm:top-28 xs:top-1 m-auto flex-wrap !important;
}
.monster-carousel >>> .slick-dots li {
  @apply sm:w-66 sm:h-66 xs:w-16 xs:h-16 md:mx-6 3sm:mx-4 xs:mx-0 xs:my-1;
}
.monster-carousel >>> .slick-dots li .dots-wrapper .slick-dots-active {
  @apply bg-black bg-opacity-75;
}
.monster-carousel
  >>> .slick-dots
  .slick-active
  .dots-wrapper
  .slick-dots-active {
  @apply bg-opacity-0 bg-transparent shadow-dots-active-2;
}
</style>
